module.exports = __webpack_public_path__ + "img/loading.63aa2ae0.png";